export default __webpack_public_path__ + "static/media/srisaila-loader.0374549f.svg";